import React, { useState } from "react";
import { ModalWithIcon } from "../../RfModal/ModalWithIcon";
import classNames from "classnames";

type CancelPlanOffersModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onCancel: () => void;
    onAcceptOffer: (offer: string) => void;
    pricePerCredit: number;
};

const offers = [
    {
        title: "+20 Roboflow Credits",
        id: "roboflowCredits",
        value: (pricePerCredit: number) => {
            return pricePerCredit * 20;
        },
        icon: "far fa-coins fa-fw"
    }
];

export function CancelPlanOffersModal({
    isOpen,
    onClose,
    onCancel,
    onAcceptOffer,
    pricePerCredit
}: CancelPlanOffersModalProps) {
    const [selectedOffer, setSelectedOffer] = useState<string>(offers[0].id);
    const [loadingAction, setLoadingAction] = useState<"offer" | "cancel" | null>(null);

    const handleAcceptOffer = async () => {
        setLoadingAction("offer");
        try {
            await onAcceptOffer(selectedOffer);
        } catch (error) {
            throw error;
        } finally {
            setLoadingAction(null);
        }
    };

    const handleCancel = async () => {
        setLoadingAction("cancel");
        await onCancel();
    };

    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            title="Instead of canceling, would you like one of these offers?"
            icon="far fa-gift"
            cancelButtonText="No Thanks, Cancel Now"
            submitButtonText="Select Offer"
            type="info"
            onCancel={handleCancel}
            onSubmit={handleAcceptOffer}
            submitButtonProps={{ disabled: !!loadingAction, loading: loadingAction === "offer" }}
            cancelButtonProps={{ disabled: !!loadingAction, loading: loadingAction === "cancel" }}
            closeOnCancel={false}
        >
            <div className="flex w-full flex-col gap-4 text-sm text-gray-700">
                {offers.map((offer, index) => (
                    <div
                        className={classNames(
                            "ease-in-ou group flex w-full cursor-pointer flex-row items-center gap-6 rounded-lg border p-4 transition duration-200",
                            selectedOffer === offer.id
                                ? "border-brand shadow-purboflow"
                                : "border-gray-200 hover:border-gray-400 hover:shadow-lg"
                        )}
                        key={index}
                        onClick={() => setSelectedOffer(offer.id)}
                    >
                        <div
                            className={classNames(
                                "flex h-11 w-11 items-center justify-center rounded-md border-0 transition duration-200",
                                selectedOffer === offer.id
                                    ? "bg-tint text-brand"
                                    : "bg-gray-100 text-gray-700"
                            )}
                        >
                            <i className={`${offer.icon} text-lg`}></i>
                        </div>
                        <div className="flex-1 text-base font-medium text-gray-900">
                            {offer.title}
                        </div>

                        <div className="rounded-md bg-tint px-2 py-1 font-mono text-xs text-brand">
                            Worth ${offer.value(pricePerCredit)}
                        </div>
                    </div>
                ))}
            </div>
        </ModalWithIcon>
    );
}
